import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Products } from './pages/Products';
import { ProductForm } from './pages/ProductForm';
import { Orders } from './pages/Orders';
import { OrderForm } from './pages/OrderForm';
import { Users } from './pages/Users';
import { ImageManager } from './pages/ImageManager';
import { Reports } from './pages/Reports';
import { ProductionTools } from './pages/ProductionTools';
import { Warehouse } from './pages/Warehouse';
import { Tailors } from './pages/Tailors';
import { Toaster } from 'sonner';

// Role groups (hoisted as module constants to avoid recreating inline arrays on every render)
const ROLES_ALL_NON_PROD = ['admin', 'sales', 'customer'];
const ROLES_STAFF = ['admin', 'sales'];
const ROLES_PROD = ['admin', 'production_team'];
const ROLES_WAREHOUSE = ['admin', 'sales', 'production_team'];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={ROLES_ALL_NON_PROD}>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/products"
            element={
              <ProtectedRoute allowedRoles={ROLES_ALL_NON_PROD}>
                <Products />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/products/new"
            element={
              <ProtectedRoute allowedRoles={ROLES_STAFF}>
                <ProductForm />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/products/edit/:productId"
            element={
              <ProtectedRoute allowedRoles={ROLES_STAFF}>
                <ProductForm />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/orders"
            element={
              <ProtectedRoute allowedRoles={ROLES_ALL_NON_PROD}>
                <Orders />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/orders/new"
            element={
              <ProtectedRoute allowedRoles={ROLES_ALL_NON_PROD}>
                <OrderForm />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/orders/:orderNumber"
            element={
              <ProtectedRoute allowedRoles={ROLES_ALL_NON_PROD}>
                <OrderForm />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/users"
            element={
              <ProtectedRoute allowedRoles={ROLES_STAFF}>
                <Users />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/media"
            element={
              <ProtectedRoute allowedRoles={ROLES_STAFF}>
                <ImageManager />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/reports"
            element={
              <ProtectedRoute allowedRoles={ROLES_STAFF}>
                <Reports />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/production"
            element={
              <ProtectedRoute allowedRoles={ROLES_PROD}>
                <ProductionTools />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/warehouse"
            element={
              <ProtectedRoute allowedRoles={ROLES_WAREHOUSE}>
                <Warehouse />
              </ProtectedRoute>
            }
          />

          <Route
            path="/tailors"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Tailors />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
